module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "assignment-step"
  }, [(_vm.canViewStep) ? [_c('div', {
    staticClass: "page-content"
  }, [(_vm.shouldShowTeacherTips) ? _c('a', {
    staticClass: "button-rounded button-rounded--teachertips ",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showTeachertips(_vm.currentStep)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--info"
  }), _vm._v("Tips")]) : _vm._e(), _vm._l((_vm.partials), function(partial) {
    return _c(partial.type + 'Partial', {
      key: partial.id,
      ref: "partials",
      refInFor: true,
      tag: "component",
      attrs: {
        "partial": partial,
        "readonly": _vm.readonly,
        "step": _vm.currentStep,
        "progress": _vm.progress
      }
    })
  })], 2), _c('nav', {
    staticClass: "action-nav"
  }, [_c('hr', {
    staticClass: "flipped"
  }), (_vm.currentStepIndex > 1) ? _c('router-link', {
    staticClass: "tag button-timid button-backward",
    attrs: {
      "to": _vm.prevStepLink
    }
  }, [_vm._v("Vorige stap")]) : _vm._e(), _c('primary-button', {
    staticClass: "action-nav__next",
    attrs: {
      "link": _vm.nextStepLink,
      "disabled": !_vm.canGoNext,
      "loading": _vm.loading
    },
    on: {
      "clicked": _vm.complete
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5759176d","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/Step.vue
// module id = IO41
// module chunks = 1